<template>
	<div>
		<el-upload action="#" list-type="picture-card" :on-preview="handlePictureCardPreview" :on-remove="handleRemove"
			:http-request="uploadAvatar" :before-upload="beforeAvatarUpload" :file-list="data.imgsList"
			:on-change="handleFileSuccess" :class="{ hide: data.imgsList.length >= 2 }">
			<div style="line-height: 140px; position: relative">
				<img src="@/assets/img/addphotoblue.png" alt="" />
				<div style="position: absolute; top: 20px; left: 30%; color: #409eff">
					添加照片
				</div>
			</div>
		</el-upload>
		<el-dialog :visible.sync="dialogVisible">
			<img width="100%" :src="data.imgsString" alt="" />
		</el-dialog>
	</div>
</template>

<script>
import *as user from '@/api/user'
export default {
	name: 'uploadImgs',
	props: {
		imgsUploadObj: {
			type: Object,
			default() {
				return {
					imgsKey: String, //字段名
					imgsString: String, //图片value字符串
					imgsList: Array //图片数组
				}
			}
		}
	},
	data() {
		return {
			data: this.imgsUploadObj,
			imagetype: 'public',
			dialogVisible: false,
			list: [],
		}
	},
	watch: {
		imgsUploadObj: {
			handler(val) {
				this.data = val
			},
			deep: true,
			immediate: true
		},
		data: {
			handler(val) {
				console.log('监控data', val);
			},
			deep: true,
			immediate: true
		}
	},
	created() {
		console.log(this.data)
	},
	methods: {
		//====================================================
		uploadAvatar(files) {
			const _file = files.file
			console.log(_file)
			let param = new FormData()
			param.append('image', files.file)
			param.append('imagetype', this.imagetype)
			console.log(param);
			user.uploadImg(param).then(
				res => {
					console.log(res, 1111111)
					// this.data.imgsString = res.showimg
					this.data.imgsList.push({ url: res.showimg })
					this.list.push(res.showimg)
					this.$emit('uploadimgFn', this.list, this.list.join(','))
					this.emptyUpload()
				},
				err => {
					console.log(err)
					this.emptyUpload()
				}
			)
			// }
		},
		beforeAvatarUpload(file) {
			const isJPG = file.type === 'image/jpeg'
			const isPng = file.type === 'image/png'
			const isLt2M = file.size / 1024 / 1024 < 2

			if (!isJPG && !isPng) {
				this.$message.error('上传图片只能是 JPG或png 格式!')
			}
			if (!isLt2M) {
				this.$message.error('上传图片大小不能超过 2MB!')
			}
			return (isJPG || isPng) && isLt2M
		},
		handleRemove(file) {
			for (const i in this.data.imgsList) {
				console.log('handleRemovehandleRemove', this.data.imgsList[i], file);
				if (this.data.imgsList[i].url === file.url) {
					this.data.imgsList.splice(i, 1)
					this.list.splice(i, 1)
					this.$emit('uploadimgFn', this.list, this.list ? this.list.join(',') : '')
				}
			}
		},
		handlePictureCardPreview(file) {
			this.data.imgsString = file.url
			this.dialogVisible = true
		},
		/**
		 * 清空上传组件
		 */
		emptyUpload() {
			const mainImg = this.$refs.upload
			if (mainImg) {
				if (mainImg.length) {
					mainImg.forEach(item => {
						item.clearFiles()
					})
				} else {
					this.$refs.upload.clearFiles()
				}
			}
		},

		handleFileSuccess() {
			// const list = []
			// for (const i in this.data.imgsList) {
			// 	list.push(this.data.imgsList[i].url)
			// }
			// console.log('子', this.data.imgsList);

			// console.log('子传值', list, list.join(','));
			// this.$emit('uploadimgFn', list, list.join(','))
		},
		//===================================================
	},
}
</script>

<style lang="less" scoped>
.hide {
	/deep/ .el-upload--picture-card {
		display: none;
	}
}
</style>
